import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import {
  ticketsSearchSchema,
  withoutTicketsSearchDefaults,
  type TicketsSearch,
} from '@/components/Tickets/search'
import { TicketsPage } from '@/components/Tickets/TicketsPage'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/tickets/')({
  validateSearch: ticketsSearchSchema,
  component: TicketsRoute,
})

function TicketsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  const onSearchChange = useCallback(
    (next: Partial<TicketsSearch>) =>
      void navigate({
        search: (current) => withoutTicketsSearchDefaults({ ...current, ...next }),
        replace: true,
      }),
    [navigate],
  )

  return <TicketsPage search={search} onSearchChange={onSearchChange} />
}
